import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "../../Hooks";
import { useStyles } from "./FmCarbonFootprintTable.style";
import { useDispatch } from "react-redux";
import { AgriSolutionState } from "../../Redux";
import { useTranslation } from "react-i18next";

export const FmCarbonTableHeaderRow = () => {
  const { headerText, firstColumnText, headerTextWidthPadding } = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ borderBottom: "1px solid #7C7C7C50" }}>
      <Box className={firstColumnText} sx={{ width: "20%", padding: "32px 0" }}>
        <span>{t("cfpTable.tableColumns.envParams")}</span>
      </Box>

      <Box
        className={headerTextWidthPadding}
        sx={{
          paddingTop: "32px",
          paddingBottom: "32px",
          backgroundColor: "#e4f5ec",
          borderRadius: "8px 8px 0 0",
          color: "#248B5B",
        }}
      >
        <span>{t("cfpTable.tableColumns.multiTech")}</span>
      </Box>

      <Box
        className={headerTextWidthPadding}
        sx={{
          paddingTop: "32px",
          paddingBottom: "32px",
          backgroundColor: "#F3F3F3",
          borderRadius: "8px 8px 0 0",
          color: "#000",
        }}
      >
        <span>{t("cfpTable.tableColumns.tradTech")}</span>
      </Box>

      <Stack direction="column" sx={{ width: "30%", paddingTop: "32px" }} alignItems={"center"}>
        <Box className={headerText}>{t("cfpTable.tableColumns.performanceRating")}</Box>

        <Stack direction="row" gap="5px" sx={{ cursor: "pointer" }} onClick={() => dispatch(AgriSolutionState.Actions.toggleIndexDialog(true))}>
          <img src={theme.images.helpCircle} alt="index" />

          <Typography sx={{ fontSize: 16, textDecoration: "solid underline" }}>{t("cfpTable.tableColumns.index")}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
